module.exports = __webpack_public_path__ + "static/img/20.c6605fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/20.png
// module id = L5Ua
// module chunks = 0